import { Field, Schema } from '../../../services';
import { Validation } from '../../../tools';

export class FieldReferenceCleaner {

  constructor(private allSchemas: Schema[]) {
  }

  public cleanAllReferenceFields(fields: Field[]) {
    const cleanedFields: Field[] = [];

    fields.forEach(field => {
      cleanedFields.push(this.cleanReferenceField(field));
    });

    return cleanedFields;
  }

  public cleanReferenceField(field: Field): Field {
    if (
      field.properties.fieldType !== 'References' ||
      !field.properties.schemaIds ||
      field.properties.schemaIds.length === 0
    ) {
      return field;
    }

    const cleanedIds: string[] = [];

    field.properties.schemaIds.forEach(id => {
      if (Validation.isValidGuid(id)) {
        cleanedIds.push(id);
      } else {
        cleanedIds.push(this.allSchemas.find(schema => schema.name === id).id);
      }
    });

    field.properties.schemaIds = cleanedIds;
    return field;

  }
}
